import React from 'react'
import { Grid, Typography, Box } from '@material-ui/core'
import { Input } from 'components'
import { BecomeExpertInProps, MaxValues } from './Interface'
import useStyles, { AddCircleIcon, AddCircleIconDisabled, DeleteIcon } from './Styles'

const BecomeExpertIn: React.FC<BecomeExpertInProps> = ({
  disabled,
  onChange,
  onRemove,
  maxValues,
  onAddItem,
  onEditItem,
  refInternal,
  becomeExpertInItems,
  indexOfItemInEditMode,
  onSubmitBecomeExpertIn
}) => {
  const classes = useStyles({})
  const currentNumberOfItems = Object.keys(becomeExpertInItems || {}).length

  const onSubmitHandler = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.which === 13 && Boolean(becomeExpertInItems[indexOfItemInEditMode])) {
      onSubmitBecomeExpertIn()
    }
  }

  const renderAddFieldButton = () => {
    if (currentNumberOfItems < maxValues && !disabled) {
      const [, lastItemValue] = Object.entries(becomeExpertInItems).pop() || [null, null]
      const disabledAdd = !lastItemValue && currentNumberOfItems > 0
      return (
        <div className={classes.row}>
          <div
            onClick={(_evt: any) => {
              if (!disabledAdd) {
                onAddItem()
              }
            }}
          >
            {disabledAdd ? <AddCircleIconDisabled fontSize="large" /> : <AddCircleIcon fontSize="large" />}
          </div>
        </div>
      )
    }

    return null
  }

  const renderRemoveButton = (editing: boolean, key: number) => {
    return editing ? (
      <div
        onClick={() => {
          onRemove(key)
        }}
      >
        <DeleteIcon />
      </div>
    ) : null
  }

  return (
    <Grid container direction="column" justify="center" className={classes.container}>
      <Grid item md={6} xs={12} ref={refInternal}>
        {Object.entries(becomeExpertInItems).map(([key, item], index) => {
          const isInEditMode = indexOfItemInEditMode === index && !disabled
          return (
            <div className={classes.item} key={key}>
              <div className={classes.value}>
                <Box style={{ flex: 1 }}>
                  {isInEditMode ? (
                    <Box style={{ display: 'flex' }}>
                      <Input
                        id={`${key}-become-expert-input`}
                        showLimit
                        limit={35}
                        value={item}
                        placeholder={'Brain cognition'}
                        onClick={() => onEditItem(index)}
                        onChanged={(value: any) => onChange(index, value)}
                        onKeyPress={onSubmitHandler}
                      />
                      {renderRemoveButton(isInEditMode, index)}
                    </Box>
                  ) : (
                    <Typography style={{ display: 'flex', flex: 1 }} onClick={() => !disabled && onEditItem(index)}>
                      <label id={`${key}-become-expert-label`} className={classes.learning}>
                        {item}
                      </label>
                    </Typography>
                  )}
                </Box>
              </div>
            </div>
          )
        })}
        {renderAddFieldButton()}
      </Grid>
    </Grid>
  )
}

BecomeExpertIn.defaultProps = {
  maxValues: MaxValues.DEFAULT,
  becomeExpertInItems: {}
}

export default React.forwardRef((props: any, ref: any) => <BecomeExpertIn {...props} refInternal={ref} />)
